import { render, staticRenderFns } from "./diagnosisEvaluationCommnet.vue?vue&type=template&id=4b104452&scoped=true&"
import script from "./diagnosisEvaluationCommnet.vue?vue&type=script&lang=js&"
export * from "./diagnosisEvaluationCommnet.vue?vue&type=script&lang=js&"
import style0 from "./diagnosisEvaluationCommnet.vue?vue&type=style&index=0&id=4b104452&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b104452",
  null
  
)

export default component.exports